import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getLevelsOfAssurance } from "../../actions";
import { getAllLevelsOfAssurance } from "../../selectors";

class LoAString extends React.Component {
  static propTypes = {
    levelsOfAssurance: PropTypes.arrayOf(PropTypes.object),
    actions: PropTypes.shape({
      getLevelsOfAssurance: PropTypes.func,
    }),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  componentDidMount() {
    if (this.props.id) {
      this.props.actions.getLevelsOfAssurance();
    }
  }

  render() {
    const { levelsOfAssurance, id } = this.props;
    const match = levelsOfAssurance.find((element) => element.id === id);
    // Assuming that only one match will be found
    return match ? <>{match.displayName}</> : <></>;
  }
}

export default connect(
  (state) => ({
    levelsOfAssurance: getAllLevelsOfAssurance(state),
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        getLevelsOfAssurance,
      },
      dispatch,
    ),
  }),
)(LoAString);
